<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-card outlined height="165" :loading="loading">
          <v-card-text>
            <language-tabs
              ref="languageTabs"
              v-model="form.translations"
              :errors="errors.translations"
              #default="{ translation, index, language, on, ...other }"
            >
              <item-translation-form
                :value="translation"
                :language-id="language.id"
                v-bind="other"
                v-on="on"
                @update-prop="updateValue($event, `translations.${index}`)"
                @valid="$emit('setValid', `translations.${index}`, $event)"
              />
            </language-tabs>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-select
          v-model="form.type_id"
          outlined
          name="type_id"
          item-value="id"
          item-text="name"
          :items="types"
          :rules="rules.type_id"
          :label="`${$t('LISTS.SELECT_TYPE')} *`"
          :error-messages="errors.type_id"
          @change="changeType"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <component
          :is="`${getContentComponent}-filter`"
          v-model="form.contentable_id"
          :default-search="form.contentable_name"
          name="contentable_id"
          prepend-icon="mdi-paperclip"
          item-value="id"
          item-text="title"
          :label="$t('LISTS.SELECT_ITEM')"
          :error-messages="errors.contentable_id"
          :disabled="disableContentTypesIds.includes(form.type_id)"
          @change="updateValue('contentable_id', $event)"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import formEditable from '@/modules/_global/mixins/form-editable';
import LinksFilter from '@/modules/documents_lists/components/forms/filters/LinksFilter';
import FilesFilter from '@/modules/documents_lists/components/forms/filters/FilesFilter';
import { CATEGORY, FILE, LINK } from '@/modules/documents_lists/common/types';
import { mapCacheActions } from 'vuex-cache';
import { notEmpty } from '@/modules/_global/variables/rules';
import { mapState } from 'vuex';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';

export default {
  name: 'ItemForm',

  components: {
    ItemTranslationForm: () => import('./ItemTranslationForm'),
    LanguageTabs: () => import('@/modules/_global/_components/LanguageTabs'),
    LinksFilter,
    FilesFilter
  },
  mixins: [formEditable, i18nRefreshData],

  data() {
    return {
      types: [],
      rules: {
        type_id: [notEmpty]
      }
    };
  },

  computed: {
    ...mapState(['loading']),
    disableContentTypesIds() {
      return [CATEGORY, null];
    },
    getContentComponent() {
      switch (this.form.type_id) {
        case FILE:
          return 'Files';
        case LINK:
          return 'Links';

        default:
          return 'Links';
      }
    }
  },

  mounted() {
    this.refreshData();
  },

  methods: {
    ...mapCacheActions('documents_lists', ['getTypes']),
    refreshData() {
      this.getTypes().then(({ data }) => {
        this.types = data.data;
      });
    },
    changeType(typeId) {
      this.form.contentable_id = null;
      if (typeId === CATEGORY) {
        this.form.children = [];
      }
      this.updateValue('type_id', typeId);
    }
  }
};
</script>

<style scoped></style>
